<template>
  <div>
    <departament-add-new
      :is-add-new-departament-sidebar-active.sync="isAddNewDepartamentSidebarActive"
      @refresh-data="() => { refDepartamentList.refreshData() }"
    />
    <list
      ref="refDepartamentList"
      sort-by="departamentoId"
      :refetch-records="fetchDepartaments"
      refetch-records-name="departamentos"
      :actions="actions"
      key-field="departamentoId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteDepartament"
      :filters.sync="filters"
    />
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'
import DepartamentAddNew from './DepartamentAddNew.vue'

export default {
  components: {
    DepartamentAddNew,
    List,
  },
  setup() {
    /* Refs */
    const refDepartamentList = ref(null)
    const isAddNewDepartamentSidebarActive = ref(false)
    /* Services */
    const { fetchDepartaments, fetchDepartament, deleteDepartament } = humanResources()
    /* Pagination */
    const tableColumns = [
      {
        label: i18n.t('humanResources.departament.columns.departament'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.departament.columns.description'),
        key: 'descripcion',
      },
      {
        label: i18n.t('humanResources.departament.columns.superviseDepartament'),
        key: 'departamentoSupervisa.nombre',
      },
      {
        label: i18n.t('humanResources.departament.columns.manager'),
        key: 'empleadoGerente.nombreEmpleado',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'Departamento',
        routeName: 'apps-human-resources-departament-edit',
        params: ['departamentoId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'Departamento',
        params: ['departamentoId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        label: i18n.t('humanResources.departament.list.newDepartamentAction'),
        aclAction: 'create',
        click: () => { isAddNewDepartamentSidebarActive.value = true },
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      // Refs & data
      refDepartamentList,
      tableColumns,
      tableActions,
      actions,
      filters,
      isAddNewDepartamentSidebarActive,
      // API Calls
      fetchDepartaments,
      fetchDepartament,
      deleteDepartament,
    }
  },
}
</script>
<style lang="scss" scoped>

</style>
